/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react/jsx-no-undef */
import React, { useState, useEffect } from "react";
import Content from "../../../Components/Dashboard/Content/Content";

import {
  Get_Broker_Response,
  GET_ALL_BROKER_RESPONSES,
} from "../../../ReduxStore/Slice/Users/BrokerResponseSlice";
import { User_Profile } from "../../../ReduxStore/Slice/Common/commoSlice.jsx";
import { useDispatch } from "react-redux";
import Modal from "../../../Components/ExtraComponents/Modal";

import Table from "../../../Components/ExtraComponents/Tables/FullDataTable";

import { fDateTimeSuffix } from "../../../Utils/Date_formet";
import { Eye } from "lucide-react";
import Swal from "sweetalert2";
import Loader from "../../../Utils/Loader";

const BrokerResponse = () => {
  const dispatch = useDispatch();
  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const [refresh, setrefresh] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [shouldAddNewColumn, setShouldAddNewColumn] = useState(false);
  const [BrokerResponseId, setBrokerResponseId] = useState({});
  const [DashboardData, setDashboardData] = useState({
    loading: true,
    data: [],
  });
  const [getType, setType] = useState("all");
  const [getStrategy, setStrategy] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [expandedSignal, setExpandedSignal] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);

  const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const user_Id = JSON.parse(localStorage.getItem("user_details"))?.user_id;
  const AdminToken = JSON.parse(localStorage.getItem("user_details"))?.token;
  const today = new Date().toISOString().split("T")[0];
  const permission = JSON.parse(localStorage.getItem("permission"));



  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);


  const data = async () => {
    const userId = isgotodashboard
      ? gotodashboard.user_id
      : user_details.user_id;
    const token = isgotodashboard ? gotodashboard.token : user_details.token;

    await dispatch(
      User_Profile({
        id: userId,
        token: token,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          const brokersWithNewColumn = [
            "12",
            "2",
            "15",
            "19",
            "7",
            "20",
            "26",
            "4",
            "25",
            "27",
            "14",
          ];

          if (brokersWithNewColumn?.includes(response?.data?.broker)) {
            setShouldAddNewColumn(true);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching user profile:", error);
      });
  };

  useEffect(() => {
    data();
  }, []);

  useEffect(() => {
    BrokerResponse();
  }, [fromDate, toDate, refresh]);


  // const handleRefresh = () => {
  //   const todayDate = new Date().toISOString().split("T")[0];

  //   setFromDate("");
  //   setToDate("");

  //   setrefresh((p) => !p);
  // };

  const handleResetAndRefresh = () => {
    const todayDate = new Date().toISOString().split("T")[0];
    // Reset Filters
    setFromDate(todayDate);
    setToDate(todayDate);
    setType("all");
    setTableLoading(true);

    setrefresh((prev) => !prev);
  };




  // Fixed createTradeSymbol function to handle string input safely
  function createTradeSymbol(input) {
    if (!input || typeof input !== "string") return "-";

    try {
      const data = input.split("|");
      const fields = {};

      data.forEach((item) => {
        const [key, value] = item.split(":");
        if (key && value) {
          fields[key] = value;
        }
      });

      const symbol = fields["Symbol"] || "";
      const strike = fields["Strike"] || "";
      const oType = fields["OType"] || "";
      const expiry = fields["Expiry"] || "";

      return `${symbol}${expiry}${strike}${oType}`;
    } catch (error) {
      console.error("Error creating trade symbol:", error);
      return "-";
    }
  }

  // Fixed columns definition
  const getColumns = () => {
    const baseColumns = [

      {
        name: "Symbol",
        selector: (row) => row.symbol,
        cell: (row) => <>
          <img
            src={
              row.servicesDetails?.img ||
              "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            }
            alt="User Avatar"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
          <div>{row.symbol || "-"}</div>
        </>,
        sortable: true,
         width: "130px",
      },
      {
        name: "Created At",
        selector: (row) => row.createdAt,
        cell: (row) => (
          <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Strategy",
        selector: (row) => row.strategy,
        cell: (row) => <>{row.strategy || "-"}</>,
        sortable: true,
      },
      {
        name: "Type",
        selector: (row) => row.type,
        cell: (row) => (
          <>{row.type == "LE" || row.type == "SE" ? "ENTRY" : "EXIT"}</>
        ),
        sortable: true,
      },
      {
        name: "Broker Name",
        selector: (row) => row.broker_name,
        cell: (row) => <>{row.broker_name || "-"}</>,
        sortable: true,
      },
      {
        name: "Order Id",
        selector: (row) => row.order_id,
        cell: (row) => <>{row.order_id || "-"}</>,
        sortable: true,
      },
      {
        name: "Order Status",
        selector: (row) => row.order_status,
        cell: (row) => <>{row.order_status || "-"}</>,
        sortable: true,
      },
      {
        name: "View",
        cell: (row) => (
          <Eye
            onClick={() => GetAllServicesName(row)}
            size={20}
            color="#198754"
            strokeWidth={2}
            className="mx-1"
            style={{ cursor: "pointer" }}
          />
        ),
        ignoreRowClick: true,
        button: true,
      },
    ];

    // Add refresh column conditionally
    if (shouldAddNewColumn) {
      baseColumns.push({
        dataField: "refresh",
        text: "Refresh",
        formatter: (cell, row) => (
          <>
            {row.order_id && row.order_view_status === "0" && (
              <button
                className="btn btn-primary d-flex ms-auto mb-3"
                type="button"
                style={{ height: "40px" }}
                onClick={(e) => Singlerefresh(e, row)}
              >
                Refresh
              </button>
            )}
          </>
        ),
      });
    }

    return baseColumns;
  };

  const Singlerefresh = async (e, row) => {
    try {
      await dispatch(
        GET_ALL_BROKER_RESPONSES({
          user_id: isgotodashboard ? gotodashboard.user_id : user_Id,
          broker_response_id: row._id,
          order_id: row.order_id,
        })
      )
        .unwrap()
        .then((response) => {
          if (response.status) {
            BrokerResponse();
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.msg,
            });
            setrefresh(!refresh);
          }
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to refresh broker response",
      });
    }
  };

  const BrokerResponse = async () => {
    try {
      await dispatch(
        Get_Broker_Response({
          _id: isgotodashboard ? gotodashboard.user_id : user_Id,
          fromDate: fromDate,
          toDate: toDate,
          token: AdminToken,
        })
      )

        .unwrap()
        .then((response) => {
          if (response.status) {
            setStrategy(response.strategy || []);
            setDashboardData({
              loading: false,
              data: response.data || [],
            });
          } else {
            setDashboardData({
              loading: false,
              data: [],
            });
          }
        });
    } catch (error) {
      setDashboardData({
        loading: false,
        data: [],
      });
    }
    finally {
      setTableLoading(false);
    }
  };

  const GetAllServicesName = (row) => {
    setBrokerResponseId(row);
    setshowModal(true);
  };

  // Fixed filtering logic
  useEffect(() => {
    if (DashboardData?.data?.length > 0) {
      let FilterResponse = DashboardData.data.filter((item) => {
        if (getType === "all") {
          return true;
        } else {
          return item.strategy === getType;
        }
      });
      setFilteredData(FilterResponse);
    } else {
      setFilteredData([]);
    }
  }, [getType, DashboardData]);

  // Safe JSON parsing function
  const safeJSONParse = (jsonString) => {
    if (!jsonString) return "";
    try {
      return typeof jsonString === "string"
        ? JSON.parse(jsonString)
        : jsonString;
    } catch (error) {
      return jsonString;
    }
  };

  // Safe JSON display function
  const displayJSON = (jsonData) => {
    if (!jsonData) return "-";

    try {
      const parsed = safeJSONParse(jsonData);
      return typeof parsed === "object"
        ? JSON.stringify(parsed, null, 2)
        : String(parsed);
    } catch (error) {
      return String(jsonData);
    }
  };

  const status = BrokerResponseId?.order_status?.toLowerCase() || "";

  const successStatuses = ["success", "completed", "complete", "done", "ok"];
  const warningStatuses = ["pending", "inprogress"];
  const isSuccess = successStatuses.includes(status);
  const isWarning = warningStatuses.includes(status);

  return (
    <Content Page_title="Broker Response" button_status={false}>
      {DashboardData?.loading ? (
        <Loader />
      ) : (
        <div className="">
          <div className="row mb-3 align-items-end filter-row">
            <div className="row g-3">

              {/* Strategies */}
              <div className="col-lg-3 col-md-4 col-12">
                <label htmlFor="select" className="form-label fw-semibold">
                  Strategies
                </label>
                <select
                  className="form-select shadow-sm"
                  id="select"
                  onChange={(e) => setType(e.target.value)}
                  value={getType}
                >
                  <option value="all">All</option>
                  {getStrategy?.map((item, index) => (
                    <option key={index} value={item.strategy_name}>
                      {item.strategy_name}
                    </option>
                  ))}
                </select>
              </div>


              {(isgotodashboard === true || permission.updatedatefilterpermission === 1) && (
                <>
                  <div className="col-lg-3 col-md-4 col-6">
                    <label className="form-label fw-semibold">From Date</label>
                    <input
                      type="date"
                      className="form-control shadow-sm"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>

                  {/* To Date */}
                  <div className="col-lg-3 col-md-4 col-6">
                    <label className="form-label fw-semibold">To Date</label>
                    <input
                      type="date"
                      className="form-control shadow-sm"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>

                </>
              )}


              {/* <div className="col-lg-3 col-md-4 col-6">
                <label className="form-label fw-semibold">From Date</label>
                <input
                  type="date"
                  className="form-control shadow-sm"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              
              <div className="col-lg-3 col-md-4 col-6">
                <label className="form-label fw-semibold">To Date</label>
                <input
                  type="date"
                  className="form-control shadow-sm"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div> */}


              {/* Filter Button */}
              <div className="col-lg-1 col-md-12 col-12 d-flex align-items-end">
                <button
                  className="btn btn-primary w-100 shadow-sm"
                  onClick={handleResetAndRefresh}
                >
                  <i className="bi bi-arrow-clockwise"></i>
                </button>


              </div>

            </div>


          </div>
          {/* <FullDataTable TableColumns={getColumns()} tableData={filteredData} /> */}
          <div className="position-relative">
            {tableLoading && (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(255,255,255,0.7)",
                  zIndex: 10,
                }}
              >
                <div className="spinner-border text-primary"></div>
              </div>
            )}

            <Table columns={getColumns()} data={filteredData} />
          </div>

        </div>
      )}


      {showModal && (
        <Modal
          isOpen={showModal}
          size="xl"
          title={
            <div className="d-flex justify-content-between align-items-center">
              <span>Details View</span>


            </div>
          }
          hideBtn={true}
          handleClose={() => setshowModal(false)}
        >
          {/* Wrap only screenshot area */}
          <div id="screenshot-area" className="table-responsive p-2">
            <table
              className="table table-bordered shadow-sm align-middle"
              style={{
                width: "100%",
                borderRadius: "8px",
                overflow: "hidden",
                tableLayout: "auto",
              }}
            >
              <tbody>
                {/* 🧍 User Name & Broker Name */}
                <tr>
                  <th style={{ width: "20%", background: "#f8f9fa", color: "#555", fontWeight: 600, fontSize: "0.9rem" }}>
                    User Name
                  </th>
                  <td style={{ width: "30%" }}>
                    {BrokerResponseId?.userDetails?.UserName || "-"}
                  </td>

                  <th style={{ width: "20%", background: "#f8f9fa", color: "#555", fontWeight: 600, fontSize: "0.9rem" }}>
                    Broker Name
                  </th>
                  <td style={{ width: "30%" }}>
                    {BrokerResponseId?.broker_name || "-"}
                  </td>
                </tr>

                {/* 📊 Symbol & Created At */}
                <tr>
                  <th style={{ background: "#f8f9fa" }}>Symbol</th>
                  <td>{BrokerResponseId?.symbol || "-"}</td>

                  <th style={{ background: "#f8f9fa" }}>Created At</th>
                  <td>
                    {BrokerResponseId?.createdAt
                      ? fDateTimeSuffix(BrokerResponseId.createdAt)
                      : "-"}
                  </td>
                </tr>

                {/* 🚦 Order Status */}
                <tr>
                  <th style={{ background: "#f8f9fa" }}>Order Status</th>
                  <td colSpan={3}>
                    <span
                      className={`badge px-3 py-2 ${isSuccess
                        ? "bg-success"
                        : isWarning
                          ? "bg-warning text-dark"
                          : "bg-danger"
                        }`}
                    >
                      {(BrokerResponseId?.order_status || "-").toUpperCase()}
                    </span>
                  </td>
                </tr>

                {/* ❌ Reject Reason */}
                <tr>
                  <th style={{ background: "#f8f9fa" }}>Reject Reason</th>
                  <td colSpan={3} className="text-danger small">
                    {BrokerResponseId?.reject_reason || "-"}
                  </td>
                </tr>

                {/* 🧾 Order ID */}
                <tr>
                  <th style={{ background: "#f8f9fa" }}>Order Id</th>
                  <td colSpan={3}>{BrokerResponseId?.order_id || "-"}</td>
                </tr>

                {/* ⚙️ Signal Section */}
                <tr>
                  <th style={{ background: "#f8f9fa" }}>Signal</th>
                  <td colSpan={3}>
                    <pre className="p-2 rounded bg-light border" style={{
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      fontSize: "12px",
                      margin: 0,
                      overflowX: "auto",
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}>
                      {displayJSON(BrokerResponseId?.send_request)}
                    </pre>
                  </td>
                </tr>

                {/* 📦 Order Data */}
                <tr>
                  <th style={{ background: "#f8f9fa" }}>Order Data</th>
                  <td colSpan={3}>
                    <pre className="p-2 rounded bg-light border" style={{
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      fontSize: "12px",
                      margin: 0,
                      maxHeight: "1000px",
                      overflowY: "auto",
                    }}>
                      {displayJSON(BrokerResponseId?.full_response)}
                    </pre>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal>
      )}

      <div
        className="alert alert-warning bg-transparent mt-3"
        style={{ fontSize: "12px" }}
      >
        <p>
          <strong>English:</strong> If your trade has been received by your
          broker and an order ID has been generated, it means your trade has
          been connected to the broker. To check the further progress of your
          trade, you will see a refresh button next to the order ID. Please
          press it to receive the complete response from your broker. If the
          order ID is not showing for your trade, it means that due to a server
          issue or incorrect information, your trade could not connect to the
          broker.
        </p>

        <p>
          <strong>Hindi:</strong> अगर आपके ट्रेड का रिस्पॉन्स आपके ब्रोकऱ से
          मिला है और उसकी ऑर्डर आईडी जनरेट हुई है, तो इसका मतलब है कि आपका ट्रेड
          ब्रोकऱ से कनेक्ट हो गया है। आगे उस ट्रेड की प्रक्रिया जानने के लिए
          आपको ऑर्डर आईडी के आगे एक रिफ्रेश का बटन दिख रहा होगा, उसे दबाएं, तो
          आपको ब्रोकऱ से पूरा रिस्पॉन्स मिल जाएगा। अगर आपके ट्रेड के आगे ऑर्डर
          आईडी नहीं दिख रही है, तो किसी सर्वर इश्यू या गलत जानकारी के कारण आपका
          ट्रेड ब्रोकऱ से कनेक्ट नहीं हो पाया है।
        </p>
      </div>
    </Content>
  );
};

export default BrokerResponse;
